import { render, staticRenderFns } from "./ValidationForm.vue?vue&type=template&id=572967f4&"
import script from "./ValidationForm.vue?vue&type=script&lang=js&"
export * from "./ValidationForm.vue?vue&type=script&lang=js&"
import style0 from "./ValidationForm.vue?vue&type=style&index=0&id=572967f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports